module.exports = __webpack_public_path__ + "img/informes.239b70d7.svg";